import React from "react";
import Accordions from "../../../components/Accordions";

const Sem7MECH = () => {
  const data = [
    {
      subjectName: "2021 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1JokuD_gWJdLuK-DFo_4rCk3bnzyqAycL/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/11E4AjMdztfi8AJ2x2BkFiSXzZF7z81Y-/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">MECH Sem - 7</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem7MECH;
